'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import browserStorageGetItem from '@haaretz/s-browser-storage-utils/getItem';
import browserStorageSetterItem from '@haaretz/s-browser-storage-utils/setItem';
import { USER_READING_HISTORY } from '@haaretz/s-consts';
import React from 'react';
import useArticleId from '../articleId';
const READING_HISTORY_COUNT_INITIAL_VALUE = [];
export const getInitialReadingHistory = ()=>{
    const item = browserStorageGetItem({
        key: USER_READING_HISTORY,
        storage: 'local'
    });
    if (item) {
        try {
            return JSON.parse(item);
        } catch (e) {
            console.error(`Error parsing reading history: ${e.message}}`);
            return READING_HISTORY_COUNT_INITIAL_VALUE;
        }
    }
    return READING_HISTORY_COUNT_INITIAL_VALUE;
};
const ReadingHistoryContext = /*#__PURE__*/ React.createContext(undefined);
export function ReadingHistoryProvider({ children }) {
    const articleId = useArticleId();
    const [readingHistory, setReadingHistory] = React.useState(getInitialReadingHistory());
    React.useEffect(()=>{
        if (articleId) {
            setReadingHistory((prev)=>{
                const updateReadingHistory = [
                    ...new Set([
                        articleId,
                        ...prev
                    ])
                ];
                if (updateReadingHistory.length > 50) updateReadingHistory.length = 50;
                browserStorageSetterItem({
                    key: USER_READING_HISTORY,
                    value: updateReadingHistory,
                    storage: 'local'
                });
                return updateReadingHistory;
            });
        }
    }, [
        articleId
    ]);
    return /*#__PURE__*/ _jsx(ReadingHistoryContext, {
        value: readingHistory,
        children: children
    });
}
export default function useReadingHistory() {
    const context = React.use(ReadingHistoryContext);
    if (context === undefined) {
        throw new Error('useReadingHistory must be used within a ReadingHistoryProvider');
    }
    return context;
}

//# sourceMappingURL=readingHistoryAtom.js.map